import React, { createContext, useState, useEffect } from 'react';
import { useMenuCategory } from '../../contexts/MenuCategoryContext';

export const MenuContext = createContext({});

const MENU_STATE_STORAGE_KEY = 'karsan_menu_state';

export const MenuProvider = (props) => {
    const { selectedCategory } = useMenuCategory();

    // localStorage'dan menü durumunu yükle
    const [activeMenu, setActiveMenuState] = useState(() => {
        try {
            const stored = localStorage.getItem(MENU_STATE_STORAGE_KEY);
            return stored || '';
        } catch (error) {
            console.error('Error reading menu state from localStorage:', error);
            return '';
        }
    });

    // Kategori değiştiğinde tüm menüleri aç
    useEffect(() => {
        if (selectedCategory) {
            // Tüm menüleri açmak için "0" key'ini kullan (root level)
            setActiveMenuState('0');
        } else {
            setActiveMenuState('');
        }
    }, [selectedCategory]);

    // activeMenu değiştiğinde localStorage'a kaydet
    const setActiveMenu = (menu) => {
        setActiveMenuState(menu);
        try {
            if (menu) {
                localStorage.setItem(MENU_STATE_STORAGE_KEY, menu);
            } else {
                localStorage.removeItem(MENU_STATE_STORAGE_KEY);
            }
        } catch (error) {
            console.error('Error writing menu state to localStorage:', error);
        }
    };

    const value = {
        activeMenu,
        setActiveMenu
    };

    return <MenuContext.Provider value={value}>{props.children}</MenuContext.Provider>;
};
